export enum MetricSizes {
  Small = 'small',
  Standard = 'standard',
}

export type MetricSize = `${MetricSizes}`;

export enum MetricVariants {
  Accent = 'accent',
  Naked = 'naked',
}

export type MetricVariant = `${MetricVariants}`;
